/* =======================================================================
   Intro — Sezione "Benvenuti" della home con la firma di Massimiliano
   =======================================================================
   Testi: src/data/copy.js → sezione "intro"
   Foto:
     • Grande verticale: public/assets/photos/real/intro-massimiliano.jpg
     • Piccola del forno: public/assets/photos/photo-1606152196365-d1ce5ea838b5.jpg
   Per sostituire una foto, sovrascrivi il file con lo stesso nome.
   ======================================================================= */
import { useLang } from "@/context/LanguageContext";
import { asset } from "@/utils/asset";

export default function Intro({ copy }) {
  const { tr } = useLang();
  return (
    <section
      data-testid="intro"
      className="relative bg-[#F7F4EB] text-[#2C2C2A] py-24 lg:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-7">
          <p className="text-[0.72rem] tracking-[0.32em] uppercase text-[#737554] mb-8">
            — {tr(copy.intro.overline)}
          </p>
          <h2 className="font-serif font-light text-[clamp(2.4rem,5.2vw,4.6rem)] leading-[1.02] tracking-tight whitespace-pre-line">
            {tr(copy.intro.title)}
          </h2>
          <p className="mt-10 max-w-2xl text-lg lg:text-xl font-light leading-[1.7] text-[#3a3a37]">
            {tr(copy.intro.body)}
          </p>

          <div className="mt-12 flex items-end gap-5">
            <div>
              <p className="font-handwriting text-5xl lg:text-6xl text-[#BC472A] leading-none">
                {tr(copy.intro.signature)}
              </p>
              <p className="mt-3 text-[0.72rem] tracking-[0.28em] uppercase text-[#737554]">
                {tr(copy.intro.signature_role)}
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 relative lg:pl-8">
          <div className="relative aspect-[4/5] overflow-hidden rounded-md">
            <img
              src={asset("/assets/photos/real/intro-massimiliano.jpg")}
              alt="Massimiliano Ciaffone al lavoro"
              className="absolute inset-0 h-full w-full object-cover hover:scale-[1.04] transition-transform duration-[1.5s] ease-out"
            />
          </div>
          <div className="absolute -bottom-10 -left-8 lg:-left-12 w-44 lg:w-56 aspect-square overflow-hidden rounded-md border-[6px] border-[#F7F4EB] hidden md:block shadow-xl">
            <img
              src={asset("/assets/photos/photo-1606152196365-d1ce5ea838b5.jpg")}
              alt="Wood fire oven"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="hidden lg:block absolute -top-6 right-0 rotate-[6deg] bg-[#BC472A] text-[#F7F4EB] px-4 py-2 text-[0.65rem] tracking-[0.32em] uppercase rounded-sm">
            Rosignano M.mo
          </div>
        </div>
      </div>
    </section>
  );
}
